/*
 * @Description: 实时定位驾驶舱 — 告警 mock（未读数 + 告警记录列表）
 *   告警记录覆盖停留超限 / 连续移动超距 / 设备下线(已恢复) / 设备上线 / 低电量。
 */
import { AlertListData } from '../types/cockpit.types'

/** 告警未读数 mock（铃铛角标用） */
export const MOCK_ALERT_UNREAD_COUNT = 3

// mock 基准时刻：今天与昨天各一批（用相对 now 计算，避免写死日期跨天失真）
const NOW = Date.now()
const DAY = 24 * 60 * 60 * 1000

/** 告警记录 mock（D1 /alerts/list，时间倒序，跨「今天 / 昨天」两组） */
export const MOCK_ALERT_LIST: AlertListData = {
  total: 6,
  pageNo: 1,
  pageSize: 20,
  hasUnread: true,
  items: [
    {
      id: 1,
      userId: 'mock-u1',
      userName: '王明',
      ruleType: 'stay_timeout',
      level: 'warn',
      title: '停留时长超限',
      content: '在「万象城东门」停留47分钟，超出17分钟',
      location: '104.0668,30.5728',
      triggeredAt: NOW - 30 * 60 * 1000,
      resolvedAt: null
    },
    {
      id: 2,
      userId: 'mock-u2',
      userName: '刘晓娥',
      ruleType: 'continuous_distance',
      level: 'warn',
      title: '连续移动超距',
      content: '5分钟内连续移动超过500米',
      location: '104.0712,30.5690',
      triggeredAt: NOW - 50 * 60 * 1000,
      resolvedAt: null
    },
    {
      id: 3,
      userId: 'mock-u3',
      userName: '徐兴泽',
      ruleType: 'offline',
      level: 'warn',
      title: '设备下线',
      content: '设备下线',
      triggeredAt: NOW - 70 * 60 * 1000,
      resolvedAt: NOW - 68 * 60 * 1000
    },
    {
      id: 4,
      userId: 'mock-u3',
      userName: '徐兴泽',
      ruleType: 'recovered',
      level: 'info',
      title: '设备上线',
      content: '11:25已恢复上线',
      triggeredAt: NOW - 68 * 60 * 1000,
      resolvedAt: null
    },
    {
      id: 5,
      userId: 'mock-u4',
      userName: '张晓辉',
      ruleType: 'low_battery',
      level: 'warn',
      title: '设备低电量',
      content: '设备电量剩余10%',
      triggeredAt: NOW - 90 * 60 * 1000,
      resolvedAt: null
    },
    {
      id: 6,
      userId: 'mock-u1',
      userName: '王明',
      ruleType: 'stay_timeout',
      level: 'warn',
      title: '停留时长超限',
      content: '在「万象城东门」停留47分钟，超出17分钟',
      location: '104.0668,30.5728',
      triggeredAt: NOW - DAY - 60 * 60 * 1000,
      resolvedAt: null
    }
  ]
}
